import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import { rootSectionWithContainer } from "SharedComponent/styles/sharedStyles";

export const useStyle = makeStyles((theme: Theme) => {
   const {
      root, 
      container
    } = rootSectionWithContainer(theme);

   return  createStyles({ 
    root,
    container: {
      flexDirection: "column",
      height: "100%",
      "& .userItem": {
        width: "100%",
        "&.heading": {
          paddingBottom: theme.spacing(2.5),
          "& p": {
            fontSize: 24,
            color: COLORS.BLACK,
            fontWeight: 600,
          },
        },
        "&.content": {
          backgroundColor: COLORS.WHITE,
          borderRadius: theme.spacing(1),
          height: "calc(100vh - 44px)",
          paddingTop: theme.spacing(1.5),
          "& .hubIdLink": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 12,
          },
          "& .serviceType": {
            color: "#2D2D2D",
            fontWeight: 500,
            fontSize: 12,
            textTransform: "capitalize",
          },
        },
      },
    },
    actionsHeader: {
      alignItems: "center",
      "& .actionItem": {
        cursor: "pointer",
        margin: "auto 0px",
        "& .icon": {
          padding: theme.spacing(0.25),
          margin: theme.spacing(0, 1, 0, 1),
          fill: COLORS.PRIMARY_MAIN,
        },
      },
    },
    // Dialog
    dialogPaperPropsRoot: {
      margin: 0,
      marginLeft: "auto",
      maxHeight: "none",
      height: "100vh",
      width: 680,
    },
    titleContainer: {
      padding: theme.spacing(0.75, 0, 0, 0),
    },
    titleContainerItem: {
      padding: 0,
      margin: "auto 0px",
    },
    titleSpanStyle: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 600,
      fontSize: 18,
      textTransform: "uppercase",
    },
    //
    renderPOSDetailsContainer: {
      padding: theme.spacing(0, 1, 0, 1),
      margin: "auto 0px",
      background: COLORS.BLACK_SQUEEZE,
      borderRadius: 8,
      border: "none",
    },
    renderPOSDetailItem: {
      display: "flex",
      justifyContent: "flex-start",
      padding: theme.spacing(1, 1, 0, 1),
      margin: "auto 0px",
      color: COLORS.MINE_SHAFT,
      fontWeight: 500,
      fontSize: 14,
    },
    renderPOSDetailSpanStyle: {
      display: "flex",
      color: COLORS.MINE_SHAFT,
      fontWeight: 500,
      fontSize: 14,
    },
    renderPOSDetailBoldSpanStyle: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 600,
      fontSize: 14,
      margin: "auto 0px auto 8px",
    },
    renderPOSDetailItemContainer: {
      padding: theme.spacing(0, 0, 1, 0),
      margin: "auto 0px",
    },
    //
    dialogButtonsContainer: {
      justifyContent: "center",
      "& .dialogBtn": { "&.primary": { marginLeft: theme.spacing(1) } },
    },
    dialogButtonsStyle: {
      width: "100%",
    },
    //
    hqrCodeDialogPaperPropsRoot: {
      width: 500,
      height: 500,
      margin: "auto",
      borderRadius: theme.spacing(1),
    },
    qrCodeMainContainer: {
      padding: theme.spacing(1, 0, 2, 0),
      margin: "auto 0px",
    },
    qrCodeMainItem: {
      padding: theme.spacing(2),
      margin: "auto 0px",
      width: "100%",
      height: "250px",
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    qrImageContainer: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      alignItems: "center",
    },
    qrImage: {
      width: "200px",
      height: "200px",
    },
    // Edit Section
    switchSectionContainer: {
      display: "flex",
      justifyContent: "flex-start",
      padding: theme.spacing(0),
      margin: theme.spacing(0),
    },
    switchSectionSpanStyle: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 400,
      fontSize: 14,
      margin: "auto 8px auto 0px",
    },
    valueSectionContainer: {
      padding: theme.spacing(1, 0, 0, 0),
      margin: theme.spacing(0),
    },
    editScreenHeaderSpanStyle: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 400,
      fontSize: 14,
      margin: "0px 0px 8px 0px",
    },
    //
    circularGridConatiner: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      height: "400px",
      alignItems: "center",
    },
    // Next to Search section data
    searchSectionContainer: {
      width: "auto",
      height: "auto",
      margin: "12px 0px",
    },
    searchSectionlSpanStyle: {
      display: "flex",
      color: COLORS.MINE_SHAFT,
      fontWeight: 400,
      fontSize: 14,
      margin: "auto 0px auto 32px",
    },
    searchSectionBoldSpanStyle: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 600,
      fontSize: 14,
      margin: "auto 0px auto 4px",
    },
    // Clubbing Configurations Section
    ClubbingSectionContainer:{
      marginTop: theme.spacing(4),
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${COLORS.CATSKILL_WHITE}`,
    },
    clubbingSectionTitle: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 600,
      fontSize: 14,
      margin: "0px 0px 10px 0px",
    },
    vehicleTabsContainer: {
      display: "flex",
      border: `1px solid ${COLORS.CATSKILL_WHITE}`,
      borderRadius: 8,
      overflow: "hidden",
      marginBottom: theme.spacing(1.5),
    },
    vehicleTab: {
      display: "flex",
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(1.25),
      cursor: "pointer",
      gap: 6,
      borderRight: `1px solid ${COLORS.CATSKILL_WHITE}`,
      "&:last-child": {
        borderRight: "none",
      },
      "& svg": {
        fontSize: 20,
        color: COLORS.MINE_SHAFT,
      },
    },
    vehicleTabActive: {
      backgroundColor: COLORS.PRIMARY_MAIN,
      "& svg": {
        color: COLORS.WHITE,
      },
      "& .MuiTypography-root": {
        color: `${COLORS.WHITE} !important`,
        fontWeight: "700 !important" as any,
      },
    },
    vehicleTabLabel: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 500,
      fontSize: 14,
    },
    clubbingCard: {
      border: `1px solid ${COLORS.CATSKILL_WHITE}`,
      borderRadius: 8,
      overflow: "hidden",
    },
    clubbingCardHeader: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(1.5, 2),
      gap: theme.spacing(1.5),
    },
    clubbingCardHeaderIconWrapper: {
      width: 36,
      height: 36,
      borderRadius: "50%",
      backgroundColor: COLORS.CATSKILL_WHITE,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      "& svg": {
        fontSize: 20,
        color: COLORS.PRIMARY_MAIN,
      },
    },
    clubbingCardHeaderTitle: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 600,
      fontSize: 14,
    },
    clubbingCardHeaderSubtitle: {
      color: COLORS.DUSTY_GRAY,
      fontWeight: 400,
      fontSize: 12,
      marginTop: 2,
    },
    clubbingRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: theme.spacing(1.25, 2),
      "& .MuiOutlinedInput-root": {
        minWidth: "50px",
        "& input": {
          padding: theme.spacing(0.875, 1),
          textAlign: "center",
          fontWeight: 600,
          fontSize: 14,
          width: 60,
        },
      },
    },
    clubbingRowLabel: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 500,
      fontSize: 14,
    },
    clubbingError: {
      display: "flex",
      alignItems: "center",
      gap: 4,
      padding: theme.spacing(0.5, 2, 1.5, 2),
      "& svg": {
        fontSize: 18,
        color: COLORS.ERROR_RED,
      },
    },
    clubbingErrorText: {
      color: COLORS.ERROR_RED,
      fontSize: 13,
      fontWeight: 400,
    },
  });
});

